interface EnvVars {
  webApiRoot: string,
  baseName: string,
};

const envVars: Record<string, EnvVars> = {};

envVars.local = {
  webApiRoot: "http://dev-webapi.mueller-inc.com",
  baseName: "pages",
};

envVars.test = {
  webApiRoot: "https://test-webapi.mueller-inc.com",
  baseName: "pages",
};

envVars.prod = {
  webApiRoot: "https://webapi.mueller-inc.com",
  baseName: "pages",
};

const output = {
  env: process.env.REACT_APP_ENV as ("local" | "test" | "prod"),
  ...envVars[process.env.REACT_APP_ENV]
};

export default output; 
